import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { AngularFireModule } from 'angularfire2';
import { AngularFireDatabaseModule } from 'angularfire2/database';

import {
  MatToolbarModule,
  MatFormFieldModule,
  MatDatepickerModule,
  MatNativeDateModule,
  MatInputModule,
  MatButtonModule,
  MatListModule,
  MatIconModule,
  MatSidenavModule,
  MatDialogModule,
  MatSlideToggleModule,
  MatExpansionModule,
} from '@angular/material';

import { FlexLayoutModule } from '@angular/flex-layout';


import { AppComponent } from './app.component';
import { MainMenuComponent } from './main-menu/main-menu.component';
import { NewTaskComponent } from './tasks/new-task/new-task.component';
import { ListTasksComponent } from './tasks/list-tasks/list-tasks.component';

import { routing} from './app-routing';
import { AuthService } from './auth/auth-service';
import { LoginComponent } from './auth/login/login.component';
import { RegisterComponent } from './auth/register/register.component';
import { AppGuard } from './auth/app-guard';
import { AppGuardAdmin } from './auth/app-guard-admin';
import { TasksServices } from './tasks/tasks-services';
import { UpdateTaskModalComponent } from './tasks/update-task-modal/update-task-modal.component';
import { AllTasksComponent } from './tasks/all-tasks/all-tasks.component';


@NgModule({
  declarations: [
    AppComponent,
    MainMenuComponent,
    NewTaskComponent,
    ListTasksComponent,
    LoginComponent,
    RegisterComponent,
    UpdateTaskModalComponent,
    AllTasksComponent
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    MatToolbarModule,
    MatFormFieldModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatInputModule,
    MatButtonModule,
    FlexLayoutModule,
    MatListModule,
    MatIconModule,
    MatSidenavModule,
    MatDialogModule,
    MatSlideToggleModule,
    MatExpansionModule,
    routing,
    FormsModule,
    AngularFireModule.initializeApp({
      apiKey: 'AIzaSyCI7tpkBpSelHrbdfRc1T775QUgPdiFRaY',
      authDomain: 'ns-tasks-82e6f.firebaseapp.com',
      databaseURL: 'https://ns-tasks-82e6f.firebaseio.com',
      projectId: 'ns-tasks-82e6f',
      storageBucket: 'ns-tasks-82e6f.appspot.com',
      messagingSenderId: '543841510638'
    }),
    AngularFireDatabaseModule
  ],
  providers: [
    AuthService,
    AppGuard,
    AppGuardAdmin,
    TasksServices
  ],
  entryComponents: [
    UpdateTaskModalComponent
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts